<template>
    <div>
        <Dialog :show-close-button="true" :show="show" width="90%"
                :has-backdrop="true" @close="$emit('close')">
            <div class="image-dialog-container">
                <div>
                    <span @click="$emit('previous')" style=""
                          class="icon arrow icon-arrow-left"></span>
                </div>
                <div>
                    <img :src="url"/>
                </div>
                <div>
                    <span @click="$emit('next')"
                          class="icon arrow icon-arrow-right"></span>
                </div>
            </div>
        </Dialog>
    </div>
</template>

<script>
    import Dialog from "./Dialog";

    export default {
        name: "ImageDialog",
        components: {
            Dialog
        },
        props: {
            show: Boolean,
            url: {
                required: true,
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>

    .image-dialog-container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }

    img {
        width: auto;
        max-width: 100%;
        height: auto;
        object-fit: contain;
    }

    ::v-deep .modal-container {
        display: flex;
        flex-flow: column;

        .title {
            margin-bottom: 20px;
        }
    }

    .arrow {
        font-size: 1.2em;
        margin: 1em;
        position: absolute;
        top: unset;
        right: unset
    }
    .icon-arrow-left{
        left: 0;
    }
    .icon-arrow-right{
        right: 0;
    }

    @media only screen and (max-width: 1200px) {
        .arrow{
            margin: 0;
        }
    }

</style>